import * as React from 'react'
import { observer } from 'mobx-react'
import MessageViewModel from '../../MessageViewModel'
import { TextMessageContentViewModel } from './TextMessageContent/TextMessageContentViewModel'
import TextMessageContent from './TextMessageContent'
import JobProgressionMessageContent from './ProgressionMessageContent'
import JobProgressionMessageContentViewModel from './ProgressionMessageContent/JobProgressionMessageContentViewModel'

interface MessageContentProps {
  message: MessageViewModel
  'data-test'?: string
}

/**
 " Message Content
 */
export default observer(function MessageContent({
  message,
  'data-test': dataTest,
}: MessageContentProps) {
  if (message.content instanceof TextMessageContentViewModel) {
    return <TextMessageContent data-test={dataTest} vm={message.content} />
  }

  if (message.content instanceof JobProgressionMessageContentViewModel) {
    return <JobProgressionMessageContent vm={message.content} />
  }

  return <>(Unknown message content)</>
})
